// extracted by mini-css-extract-plugin
export default {"main_container":"TermsPage_main_container__vaUmY","container":"TermsPage_container__37AYs","title":"TermsPage_title__OepmG","desc":"TermsPage_desc__GyLEH"};